module.exports = __webpack_public_path__ + "static/media/teacher_view_filter_video.fad10ee8.mov";